import React from 'react'
import _ from 'lodash'
import TitleContentColumns from './TitleContentColumns'
import KeyArrayTable from './KeyArrayTable'
import { alphabetizeByKey } from '../util.js'
import '../assets/css/components/associated-ngss-standards-table.css'
import PropTypes from 'prop-types'
/*
 * Component for displaying a table for the 4 dimensions of the NGSS
*/
const AssociatedNgssStandardsTable = ({pes, dcis, seps, cccs}) => {

  return(
    <div className='standards-table-wrapper'>
      {!_.isEmpty(pes) &&
        <TitleContentColumns title='Performance Expectations'>
          <KeyArrayTable tableType='performance-expectations' object={alphabetizeByKey(pes)} />
        </TitleContentColumns>
      }
      {!_.isEmpty(dcis) &&
        <TitleContentColumns title='Disciplinary Core Ideas'>
          <KeyArrayTable tableType='dci-clauses' object={alphabetizeByKey(dcis)} />
        </TitleContentColumns>
      }
      {!_.isEmpty(seps) &&
        <TitleContentColumns title='Science & Engineering Practices'>
          <KeyArrayTable tableType='sep-clauses' object={alphabetizeByKey(seps)} />
        </TitleContentColumns>
      }
      {!_.isEmpty(cccs) &&
        <TitleContentColumns title='Crosscutting Concepts'>
          <KeyArrayTable tableType='ccc-clauses' object={alphabetizeByKey(cccs)} />
        </TitleContentColumns>
      }
    </div>
  )
}
/*Each of the 4 props below are objects that have the name of the dimension as keys,
 * and the description/clause of the dimension as the value*/
AssociatedNgssStandardsTable.propTypes = {
  pes: PropTypes.object.isRequired,
  dcis: PropTypes.object.isRequired,
  seps: PropTypes.object.isRequired,
  cccs: PropTypes.object.isRequired
}

export default AssociatedNgssStandardsTable;
